module.exports = __webpack_public_path__ + "img/icon_slide_down_arrow.73dc2fd4.svg";